export default __webpack_public_path__ + "static/2-a26912794be92b27051728fbaac47687.webp";